<template>
  <div>
    <v-card outlined tile>
      <v-card-title class="pb-0">Rechnungs- und Versandadresse</v-card-title>
      <v-card-text>
        <span class="caption">
          Eine abweichende Lieferanschrift und Adresszusätze können Sie im Kommentarfeld angeben.
        </span>
        <v-form ref="form" v-model="valid" lazy-validation class="mt-4">
          <v-row>
            <v-col cols="6" class="py-0 my-0">
              <v-text-field
                autofocus
                v-model="firstName"
                :rules="nameRules"
                label="Vorname"
                :autocomplete="'given-name'"
                name="given-name"
                required
                color="greend"
              ></v-text-field>
            </v-col>
            <v-col cols="6" class="py-0 my-0">
              <v-text-field
                v-model="lastName"
                :rules="nameRules"
                label="Nachname"
                :autocomplete="'family-name'"
                name="family-name"
                required
                color="greend"
              ></v-text-field>
            </v-col>
            <v-col cols="12" class="py-0 my-0">
              <v-text-field
                v-model="street"
                :rules="[v => !!v || 'Pflichtfeld']"
                label="Straße + Nr."
                :autocomplete="'shipping street-address'"
                name="ship-address"
                required
                color="greend"
              ></v-text-field>
            </v-col>
            <v-col cols="3" class="py-0 my-0">
              <v-text-field
                v-model="plz"
                :rules="[v => !!v || 'Pflichtfeld']"
                label="PLZ"
                :autocomplete="'shipping postal-code'"
                name="ship-zip"
                required
                color="greend"
              ></v-text-field>
            </v-col>
            <v-col cols="9" class="py-0 my-0">
              <v-text-field
                v-model="city"
                :rules="[v => !!v || 'Pflichtfeld']"
                label="Stadt"
                :autocomplete="'address-level2'"
                name="ship-city"
                required
                color="greend"
              ></v-text-field>
            </v-col>
            <v-col cols="12" class="py-0 my-0">
              <v-text-field
                v-model="email"
                :rules="emailRules"
                label="E-Mail"
                :autocomplete="'email'"
                name="email"
                required
                color="greend"
              ></v-text-field>
            </v-col>
            <v-col cols="12" class="py-0 my-0">
              <v-textarea
                v-model="comment"
                :rules="commentRules"
                label="Kommentar"
                rows="1"
                auto-grow
                color="greend"
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row align="center">
            <v-spacer></v-spacer>
            <v-col align="right">
              <v-btn
                :disabled="!valid"
                color="greend"
                @click="validate"
                class="white--text"
              >
                Fortfahren
              </v-btn>
            </v-col>
            <v-col order="first">
              <v-btn @click="reset" text class="grey--text" small>
                Felder leeren
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  data: () => ({
    valid: true,
    firstName: "",
    lastName: "",
    street: "",
    plz: "",
    city: "",
    comment: "",
    nameRules: [
      v => !!v || "Pflichtfeld",
      v => (v && v.length <= 25) || "Der Name darf max. 25 Zeichen lang sein"
    ],
    email: "",
    emailRules: [
      v => !!v || "Pflichtfeld",
      v => /.+@.+\..+/.test(v) || "Dies ist keine gültige E-Mail Adresse"
    ],
    commentRules: [
      v => v.length <= 500 || "Der Kommentar darf max. 500 Zeichen lang sein"
    ],
    checkbox: false
  }),

  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        this.submit();
      } else {
        this.$ga.event("Checkout", "Customer Data validation failed", "Customer Data validation failed at ShippingInfo");
      }
    },
    reset() {
      this.$ga.event("Checkout", "Customer Data reset", "Customer Data reset at ShippingInfo");
      this.$refs.form.reset();
    },
    submit() {
      this.$store.state.firstName = this.firstName;
      this.$store.state.lastName = this.lastName;
      this.$store.state.street = this.street;
      this.$store.state.plz = this.plz;
      this.$store.state.city = this.city;
      this.$store.state.email = this.email;
      this.$store.state.comment = this.comment;
      this.$router.push("checkout");
    }
  },
  mounted() {
    this.firstName = this.$store.state.firstName;
    this.lastName = this.$store.state.lastName;
    this.street = this.$store.state.street;
    this.plz = this.$store.state.plz;
    this.city = this.$store.state.city;
    this.email = this.$store.state.email;
    this.comment = this.$store.state.comment;
  }
};
</script>